import type { IContentResult } from '@quesmed/types/models';
import { ImCross } from 'react-icons/im';
import { LuDownload } from 'react-icons/lu';
import { cn, Snippet } from '@/core/ui';
import { fileDownload } from '@/utils';

type FeedbackProps = {
  showDefault?: boolean;
  response?: Partial<IContentResult>;
  plain?: boolean;
  message?: string;
};

export const ErrorFeedback = ({ response, message, plain = false, showDefault = false }: FeedbackProps) => {
  const alternateName = `REPORT_${Date.now().toString().slice(0, 7)}.json`;
  const onReportDownload = () => {
    if (!response) {
      return;
    }
    fileDownload(response.logFile || `REPORT_${Date.now()}.json`, JSON.parse(response.errors || 'null'));
  };

  if (plain) {
    return (
      <div className='flex space-x-5 items-center'>
        <ImCross className='text-danger w-7 h-7' />
        <div className='flex flex-col space-y-1'>
          <span>
            Error:&nbsp;<span>{message || response?.message}</span>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className='w-full px-8 flex flex-col space-y-6 justify-center items-center'>
      <Snippet
        tooltipProps={{
          content: 'Click to download',
          placement: 'right',
        }}
        onCopy={onReportDownload}
        copyIcon={<LuDownload className='w-5 h-5' />}
        checkIcon={<LuDownload className='w-5 h-5' />}
        size='md'
        color='danger'
        symbol='LOG:'
      >
        {response?.logFile || alternateName}
      </Snippet>
      <div className='flex items-center space-x-4'>
        <ImCross className={cn('text-danger w-9 h-9', { 'w-6 h-6': !showDefault })} />
        <div className='flex flex-col space-y-1'>
          {showDefault && (
            <span> Oops! Content has some errors! Download above generated report for review.</span>
          )}
          <span className=''>
            <b>ERROR</b>:&nbsp;
            <span className=''>{response?.message}</span>
          </span>
        </div>
      </div>
    </div>
  );
};
